import { AIS_DATA_LIST, AIS_DATA_LIST_ERROR, AIS_DATA_LIST_SUCCESS, AIS_NAME_FILTER, AIS_NAME_FILTER_ERROR, AIS_NAME_FILTER_SUCCESS, DETECTION_ALGORITHM_LIST, DETECTION_ALGORITHM_LIST_ERROR, DETECTION_ALGORITHM_LIST_SUCCESS, DETECTION_CLUSTER_LIST, DETECTION_CLUSTER_LIST_ERROR, DETECTION_CLUSTER_LIST_SUCCESS, DETECTION_CLUSTER_VESSEL_DATA_LIST, DETECTION_CLUSTER_VESSEL_DATA_LIST_ERROR, DETECTION_CLUSTER_VESSEL_DATA_LIST_SUCCESS, DETECTION_GROUP_LIST, DETECTION_GROUP_LIST_ERROR, DETECTION_GROUP_LIST_SUCCESS, REALTIME_DETECTION_DATA, REALTIME_DETECTION_DATA_ERROR, REALTIME_DETECTION_DATA_SUCCESS, REALTIME_DETECTON_ALARM_DATA, REALTIME_DETECTON_ALARM_ERROR, REALTIME_DETECTON_ALARM_SUCCESS, UPDATE_REALTIME_DETECTION_LIST, UPDATE_REALTIME_DETECTION_LIST_DETAILS, UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR, UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS, UPDATE_REALTIME_DETECTION_LIST_ERROR, UPDATE_REALTIME_DETECTION_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS } from './constants';

export default function vesseltrackerreducer(state, action) {

	// let vessel_name = [];
	let aisdata = [];

	switch (action.type) {
		

	case DETECTION_CLUSTER_LIST:
		return { ...state, pending: true };
	case DETECTION_CLUSTER_LIST_SUCCESS:
		return { ...state, realtimedetection_data: action.payload, pending: false };
	case DETECTION_CLUSTER_LIST_ERROR:
		return { ...state, realtimedetection_data:action.payload,error: true, pending: false };

	case DETECTION_GROUP_LIST:
		return { ...state, pending: true };
	case DETECTION_GROUP_LIST_SUCCESS:
		return { ...state, realtimedetection_data: action.payload, pending: false };
	case DETECTION_GROUP_LIST_ERROR:
		return { ...state, realtimedetection_data:action.payload,error: true, pending: false };

	case DETECTION_CLUSTER_VESSEL_DATA_LIST:
		return { ...state, pending: true };
	case DETECTION_CLUSTER_VESSEL_DATA_LIST_SUCCESS:
		return { ...state, vessel_name: action.payload, pending: false };
	case DETECTION_CLUSTER_VESSEL_DATA_LIST_ERROR:
		return { ...state, vessel_name: action.payload, error: true, pending: false };

	case UPDATE_REALTIME_DETECTION_LIST:
		return { ...state, pending: true };

	case UPDATE_REALTIME_DETECTION_LIST_SUCCESS:
		return { ...state, pending: false };

	case UPDATE_REALTIME_DETECTION_LIST_ERROR:
		return { ...state,  error: true, pending: false };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };

	case REALTIME_DETECTION_DATA:
		return { ...state, pending: true };
	case REALTIME_DETECTION_DATA_SUCCESS:
		return { ...state, patch_data: action.payload,  };
	case REALTIME_DETECTION_DATA_ERROR:
		return { ...state, error: true,  };

	case UPDATE_REALTIME_DETECTION_LIST_DETAILS:
		return { ...state, pending: true };

	case UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details: action.payload, error: false };

	case UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case REALTIME_DETECTON_ALARM_DATA:
		return { ...state, pending: true };
	case REALTIME_DETECTON_ALARM_SUCCESS:
		return { ...state, inspection_alarm: action.payload,  };
	case REALTIME_DETECTON_ALARM_ERROR:
		return { ...state, error: true,  };

	case DETECTION_ALGORITHM_LIST:
		return {...state, loading : false , error : false};
	case DETECTION_ALGORITHM_LIST_SUCCESS:
		return { ...state, detectionalgorithm:action.payload ,  loading: false, error: false };
	case DETECTION_ALGORITHM_LIST_ERROR:
		return {...state, loading : false , error : true};

	case AIS_DATA_LIST:
		return { ...state, pending: true };
		
	case AIS_DATA_LIST_SUCCESS:
		
		if (action.payload && action?.payload?.data?.length > 0) {
		
			action?.payload?.data?.map((item) => {
				let data = {};
				data.datetime = item.datetime ? item.datetime : null ;
				data.latitude = item && item?.latitude ? item.latitude : [];
				data.longitude = item && item?.longitude ? item.longitude : [];
				data.name = item && item?.name ? item.name : 'No Data';
				data.speed = item && item?.speed ? item.speed : [];
		
				return aisdata.push(data);
			});
		
			return { ...state, aisdata: aisdata, error: false };
		
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, aisdata: [], error: false };
			} else {
				return { ...state, error: true };
			}
		}
		
	case AIS_DATA_LIST_ERROR:
		return { ...state, error: true };

	case AIS_NAME_FILTER:
		return { ...state, pending: true };

	case AIS_NAME_FILTER_SUCCESS:
		return { ...state, ais_name: action.payload, pending: false };

	case AIS_NAME_FILTER_ERROR:
		return { ...state, ais_name: action.payload, error: true, pending: false };

	default: {
		throw Error('Unknown action: ' + action.type);
	}}
}